{
    "image_upload_error": "Не удалось загрузить изображение. Попробуйте обновить страницу и выберите изображение еще раз.",
    "search_placeholder": "Поиск фото и иллюстраций",
    "search": "Найти",
    "photo": "Изображение",
    "image_by": "от",
    "free_photos_from": "Бесплатные стоковые изображения из",
    "uploading": "Загрузка",
    "cancel": "Отмена",
    "select": "Выбрать"
}
